import React from 'react'
import GiftcardPage from "../Components/Giftcards/giftcard"

const Giftcard = () => {
  return (
   <GiftcardPage />
  )
}

export default Giftcard